import { action, extendObservable } from 'mobx';
import PropTypes from 'prop-types';
import FlagStore from '../FlagStore';

export default class UISettingsStore {
    static PropType = PropTypes.shape({
        flags: PropTypes.object.isRequired,

        hasChanged: PropTypes.bool.isRequired,

        setFromObject: PropTypes.func.isRequired,
        toObject: PropTypes.func.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class UISettingsStore */{
            flags: {
                printEnabled: new FlagStore(false),
                clearCookiesEnabled: new FlagStore(false),
                feedbackEnabled: new FlagStore(false),
                faqEnabled: new FlagStore(false),
                settingsResearchMode: new FlagStore(false),
                adBlockSwitchEnabled: new FlagStore(true),
                blockAdsByDefault: new FlagStore(true),
            },
            data: null,

            get hasChanged() {
                return !!this.data && Object.keys(this.flags).some((key) => this.flags[key].value !== this.data[key]);
            },
        }, data);
    }

    setFromObject = action((data) => {
        this.data = data;
        Object.keys(this.flags).forEach((key) => this.flags[key].setValue(data[key]));
    });

    toObject = () =>
        Object.keys(this.flags).reduce((res, key) => { res[key] = this.flags[key].value; return res; }, {});
}
